module.exports = __webpack_public_path__ + "assets/img/teacher (45).cd5b2b4a.png";